import axios from 'axios';

/**
 * Instance Axios centrale
 * Toutes les requêtes passent par ici.
 */
//const api = axios.create({
//  baseURL: 'http://82.165.198.113:3000',
//});
const api = axios.create({
  baseURL: '/api',
});

// Injecte le token JWT sur chaque requête
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirige vers login si 401
api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.dispatchEvent(new Event('auth:logout'));
    }
    return Promise.reject(err);
  }
);

export const authLogin = (email, password) =>
  api.post('/auth/login', { email, password });

export const authMe = () => api.get('/auth/me');

export const changePassword = (currentPassword, newPassword) =>
  api.post('/auth/change-password', { currentPassword, newPassword });

export const getUsers = () => api.get('/auth/users');

export const createUser = (data) => api.post('/auth/users', data);

export const resetUserPassword = (id, newPassword) =>
  api.put(`/auth/users/${id}/password`, { newPassword });

export const updateUserRole = (id, role) =>
  api.put(`/auth/users/${id}/role`, { role });

export const deleteUser = (id) => api.delete(`/auth/users/${id}`);

/* ======================================================
   TRANSACTIONS
====================================================== */

export const getTransactions = () => api.get('/transactions');
export const addTransaction = (data) => api.post('/transactions', data);
export const deleteTransaction = (id) => api.delete(`/transactions/${id}`);
export const splitTransaction = (id, splits) => api.post(`/transactions/${id}/split`, { splits });

/**
 * 🏖 Toggle vacation flag
 */
export const toggleVacation = (id, is_vacation) =>
  api.patch(`/transactions/${id}/vacation`, { is_vacation });

/* ======================================================
   IMPORT CSV BANCAIRE
====================================================== */

export const importCSV = (formData) =>
  api.post('/import/bank-csv', formData);

/* ======================================================
   DASHBOARD
====================================================== */

export const getMonthlyDashboard = (month) =>
  api.get(`/dashboard/month?month=${month}`);

export const getMonthlyCategories = (month) =>
  api.get(`/categories/month?month=${month}`);

/* ======================================================
   MERCHANTS
====================================================== */

export const getMerchants = () => api.get('/merchants');
export const updateMerchant = (id, data) =>
  api.put(`/merchants/${id}`, data);
export const deleteMerchant = (id) =>
  api.delete(`/merchants/${id}`);

/**
 * ✏ Rename merchant (auto alias learning)
 */
export const renameMerchant = (id, data) =>
  api.patch(`/merchants/${id}/rename`, data);

/**
 * 🔀 Merge merchant source into target
 */
export const mergeMerchant = (id, data) =>
  api.post(`/merchants/${id}/merge`, data);

/* ======================================================
   CATEGORIES
====================================================== */

export const getCategories = () => api.get('/categories');
export const createCategory = (data) => api.post('/categories', data);
export const updateCategory = (id, data) =>
  api.put(`/categories/${id}`, data);
export const deleteCategory = (id) =>
  api.delete(`/categories/${id}`);

/* =========================
   SUBCATEGORIES CRUD
========================= */

export const createSubcategory = (data) =>
  api.post('/categories/subcategory', data);

export const updateSubcategory = (id, data) =>
  api.put(`/categories/subcategory/${id}`, data);

export const deleteSubcategory = (id) =>
  api.delete(`/categories/subcategory/${id}`);

/* ======================================================
   ⭐ NEW BUDGET ENGINE
====================================================== */

export const getBudgetSuggestions = (month) =>
  api.get(`/budget/suggestions?month=${month}`);

export const getBudgetMonth = (month) =>
  api.get(`/budget/month?month=${month}`);

export const saveBudgetMonth = (data) =>
  api.post('/budget/month', data);

export const getBudgetStatus = (month) =>
  api.get(`/budget/month/status?month=${month}`);

export const getBudgetTrends = (month, months) =>
  api.get(`/budget/trends?month=${month}&months=${months}`);

export const budgetExists = (month) =>
  api.get(`/budget/month/exists?month=${month}`);

/* ======================================================
   ADMIN
====================================================== */

/**
 * 🔴 Réinitialisation complète (transactions + merchants + aliases)
 * Les catégories sont conservées.
 */
export const resetData = () => api.post('/admin/reset');

export default api;